<script setup lang="ts">
import type { NavigationTreeFragment } from '#graphql-operations'

interface HeaderNavProps {
  nav: NavigationTreeFragment[]
}

defineProps<HeaderNavProps>()

const route = useRoute()
const { isActive, open, close } = useMagicDrawer('navigation-mobile-drawer')

function toggle() {
  isActive.value ? close() : open()
}

watch(route, () => {
  close()
})
</script>

<template>
  <aside class="theNavigationMobile mobile-only contents">
    <Burger :open="isActive" class="z-5" @click="toggle" />
    <MagicDrawerProvider
      id="navigation-mobile-drawer"
      :options="{
        position: 'right',
        // threshold: {
        //   distance: 0,
        //   momentum: 0,
        // },
        scrollLock: {
          padding: false,
        },
      }"
    >
      <MagicDrawerBackdrop />
      <MagicDrawerContent>
        <div class="bg-$primary-color absolute -inset-4rem" />
        <div class="c-$negative-color text-left size-full justify-between relative z-1 of-y-auto">
          <nav v-if="nav && nav.length > 0" class="headerNavMobile px-4 pb-6 pt-12 gap-y-12 grid grid min-h-full relative">
            <MagicAccordionProvider id="mobile-nav" class="flex flex-col gap-4" as-child :options="{ mode: 'single' }">
              <ul>
                <template v-for="item in nav" :key="item!.id">
                  <HeaderNavSubmenuMobile
                    v-if="(item.children?.length || 0) > 0"
                    :nav="item"
                  />
                  <HeaderNavLink
                    v-else
                    :link="item"
                  />
                </template>
              </ul>
            </MagicAccordionProvider>

            <SiteSwitchComponent name="monogram" class="c-$secondary-color mt-auto flex-none w-29 lg:mx-0 lg:w-57" :font-controlled="false" />
          </nav>
        </div>
      </MagicDrawerContent>
    </MagicDrawerProvider>
  </aside>
</template>

<style scoped>
.theNavigationMobile {
  --magic-drawer-z-index: 4;
  --magic-drawer-height: 100%;
  --magic-drawer-drag-overshoot: 0rem;

  --magic-drawer-enter-animation: slide-rtl-in 0.7s var(--ease-custom-expo);
  --magic-drawer-leave-animation: slide-rtl-out 0.6s var(--ease-custom-expo);

  @screen lg {
    --magic-drawer-enter-animation: slide-btt-in 0.7s var(--ease-custom-expo);
    --magic-drawer-leave-animation: slide-btt-out 0.6s var(--ease-custom-expo);
  }
}

:deep(.burger) {
  --uno: motion-base;
}

:deep(.burger.is-open) {
  color: var(--colors-linen);
}
</style>
